import React, { useCallback, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import AddLocation from "./business-location/AddLocation";
import LocationList from "./business-location/LocationList";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const LocationSetup = ({ businessLocationData, activeStepRef , IsMaxView }) => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [stepKey, setStepKey] = useState(0); // Used to force SwipeableViews rerender

    const handleStepChange = useCallback((step) => {
        activeStepRef.current = step;
        setStepKey(prev => prev + 1); // Force rerender
    }, []);

    return (
        <SwipeableViews
            key={stepKey} // Key triggers re-render when step changes
            enableMouseEvents={false}
            index={activeStepRef.current}
            onChangeIndex={handleStepChange}
        >
            <LocationList
                businessLocationData={businessLocationData}
                onAddLocation={() => {
                    setSelectedLocation(null);
                    activeStepRef.current = 1;
                    setStepKey(prev => prev + 1);
                }}
                onEditLocation={(location) => {
                    setSelectedLocation(location);
                    activeStepRef.current = 1;
                    setStepKey(prev => prev + 1);
                }}
                IsMaxView={IsMaxView}
            />
            <AddLocation
                businessLocationData={businessLocationData}
                locationToEdit={selectedLocation}
                onBack={() => {
                    activeStepRef.current = 0;
                    setStepKey(prev => prev + 1);
                }}
                onClose={() => {
                    activeStepRef.current = 0;
                    setSelectedLocation(null);
                    setStepKey(prev => prev + 1);
                }}
            />
        </SwipeableViews>
    );
};

export default LocationSetup;